import {useMemo} from 'react';
import {AddToCartState} from '@wix/wixstores-client-storefront-sdk/dist/es/src/services/AddToCartService/constants';
import {useGlobals} from '../../../providers/globalPropsProvider';

type TranslationFunction = (key: string) => string;

export function useStickyButtonText(t: TranslationFunction): string {
  const {currentPrice, labelOverrides, addToCartState, isUserInputsValid} = useGlobals();

  return useMemo(() => {
    const defaultText =
      addToCartState === AddToCartState.PRE_ORDER ? t('productPage.preOrder.button') : t('ADD_TO_CART_BUTTON');
    const baseText = labelOverrides?.cta?.addToCart || defaultText;
    return isUserInputsValid && currentPrice?.formattedActualPrice
      ? `${baseText} - ${currentPrice.formattedActualPrice}`
      : baseText;
  }, [addToCartState, t, labelOverrides?.cta?.addToCart, isUserInputsValid, currentPrice?.formattedActualPrice]);
}
